let hosts = HOSTS;

if (/useTestServer/.test(window.location.href)) {
  hosts = {
    ...HOSTS,
    catalog: '//vod-test.wix.com/',
    files: '//vod-meta-test.wix.com/',
    image: '//images-vod-test.wix.com/',
    video: '//storage.googleapis.com/wixmp-vod-gptest/',
    paypal: '//dgs-test.wixapps.net/',
    cashier: 'https://dgs-test.wixapps.net/',
    pixWix: '//pix.wix.com/services',
  };
}

export default {
  hosts,
};



// WEBPACK FOOTER //
// ./src/shared/settings.js